import { useConfigurationQuery } from 'App/actions/api/configuration';
import { useUserQuery } from 'App/actions/api/user';
import { initializeFoundation } from 'App/actions/zitadel';
import { useLogout } from 'App/api/auth';
import { FOUNDATION } from 'config/features';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOrganizationShortName } from 'store/hooks/useOrganizationShortName';
import { selectors as tokenSelectors } from 'store/jwtMiddleware/tokenDuck';

import Initialize from './Initialize';

const EMPTY_USER = {};

const InitializeContainer = props => {
  const dispatch = useDispatch();
  const { isSuccess, isError } = useConfigurationQuery();
  const configurationInitialized = isSuccess || isError;
  const { data: user, isError: userError } = useUserQuery();
  const organizationShortName = useOrganizationShortName();
  const token = useSelector(tokenSelectors.token);
  const invalidRoles = useSelector(tokenSelectors.invalidRoles);
  const logout = useLogout();
  const initializeFoundationCallback = useCallback(() => dispatch(initializeFoundation()), [dispatch]);

  useEffect(() => {
    if (userError && !user && !FOUNDATION) {
      logout();
    }
  }, [userError, user, logout]);

  return (
    <Initialize
      {...props}
      configurationInitialized={configurationInitialized}
      user={user ?? EMPTY_USER}
      organizationShortName={organizationShortName}
      token={token}
      invalidRoles={invalidRoles}
      initializeFoundation={initializeFoundationCallback}
    />
  );
};

export default InitializeContainer;
